var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({key:_vm.fieldKey,attrs:{"label":_vm.label,"suffix":_vm.suffix,"isFloat":_vm.isFloat,"value":_vm.formattedValue},on:{"input":_vm.handleInput,"keydown":_vm.handleKeyDown}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }